import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function ResultsWhatTheySaid() {
  const testimonials = [{
    quote: "I think it was the best thing we've ever invested in... if it wasn't for that, they wouldn't be where they are and I would still be banging my head against a brick wall.",
    author: 'Pali Dhanoya',
    role: 'Head of Product, HTEC Group'
  }, {
    quote: "The course didn't just teach me tools. It gave me the strategic foundation and confidence to take on AI leadership roles.",
    author: 'Kate Mosley',
    role: 'Group Product Manager'
  }, {
    quote: 'This class is a cheat code for Product Managers and Leaders who need to accelerate their understanding and use of AI to build and ship in this new era.',
    author: 'John',
    role: 'Digital Media Product Consultant'
  }];
  return <section className="w-full bg-brand-navy py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-277" data-mp="3975m8jvnz3hm">
      <div className="max-w-7xl mx-auto" data-id="element-278" data-mp="2rwwolggtldi8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-279" data-mp="2rxybci777ofs">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white/5 p-10 md:p-12 rounded-lg border-l-4 border-brand-orange relative flex flex-col h-full" data-id="element-280" data-mp="2vz0br2cuq6jc" data-mpi={index}>
              <QuoteIcon className="w-10 h-10 text-brand-orange/20 absolute top-8 left-8" data-id="element-281" data-mp="35xpoyhtsz2t9" />
              <blockquote className="text-xl text-white leading-relaxed italic mb-10 relative z-10 flex-grow" data-id="element-282" data-mp="3aupsom36jth7">
                "{testimonial.quote}"
              </blockquote>
              <div className="mt-auto" data-id="element-283" data-mp="3jochttcvtyhf">
                <div className="font-bold text-white text-lg" data-id="element-284" data-mp="3jomchu8vgttg">
                  {testimonial.author}
                </div>
                <div className="text-brand-orange text-base mt-2" data-id="element-285" data-mp="3op9zm4tzcqie">
                  {testimonial.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}